module.exports = __webpack_public_path__ + "img/icon-12.4c7d6406.png";